import { api } from "./api";

const KEY = "ihmj_progress";
const token = () => localStorage.getItem("ihmj_token");

export const getLocalProgress = () => {
  try { return JSON.parse(localStorage.getItem(KEY)) || {}; } catch { return {}; }
};

export const setLocalProgress = (patch) => {
  const merged = { ...getLocalProgress(), ...patch };
  localStorage.setItem(KEY, JSON.stringify(merged));
  return merged;
};

export const clearLocalProgress = () => localStorage.removeItem(KEY);

// Persist a patch: localStorage always, backend too when signed in.
export const syncProgress = (patch) => {
  setLocalProgress(patch);
  if (!token()) return;
  const body = {};
  ["answers", "step", "last_route", "chosen_path"].forEach((k) => {
    if (patch[k] !== undefined && patch[k] !== null) body[k] = patch[k];
  });
  if (Object.keys(body).length) api.post("/progress", body).catch(() => {});
};

// Pull server progress into localStorage (server wins) when signed in.
export const loadProgress = async () => {
  if (!token()) return getLocalProgress();
  try {
    const { data } = await api.get("/progress");
    const server = data.progress || {};
    const clean = {};
    ["answers", "step", "last_route", "chosen_path"].forEach((k) => {
      if (server[k] !== undefined && server[k] !== null) clean[k] = server[k];
    });
    return setLocalProgress(clean);
  } catch { return getLocalProgress(); }
};

// After login/register: attach any pre-signup answers, then decide where to land — from the DB.
export const flushProgressAfterAuth = async (fallback = "/dashboard") => {
  const lp = getLocalProgress();
  if (lp.pending_quiz) {
    try {
      await api.post("/quiz", lp.pending_quiz, { timeout: 20000 });
      setLocalProgress({ pending_quiz: null });
    } catch { /* keep the answers locally; Dashboard retries */ }
  }
  try {
    const { data } = await api.get("/resume");
    if (data.quiz_completed) return "/dashboard";
    // Brand-new account with nothing saved server-side: attach pre-signup partial answers.
    if (!data.step && lp.answers && Object.keys(lp.answers).length > 3 && typeof lp.step === "number" && lp.step > 0) {
      await api.post("/progress", { answers: lp.answers, step: lp.step }).catch(() => {});
    }
    return data.destination || "/quiz";
  } catch {
    return fallback;
  }
};
